import { __awaiter, __decorate, __extends, __generator } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
var QuestionPage = /** @class */ (function (_super) {
    __extends(QuestionPage, _super);
    function QuestionPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.survey = null;
        return _this;
    }
    QuestionPage.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.survey = this.$store.state.survey;
                return [2 /*return*/];
            });
        });
    };
    QuestionPage = __decorate([
        Component({})
    ], QuestionPage);
    return QuestionPage;
}(Vue));
export default QuestionPage;
